const REQUEST_CHANGE_TIME_REPORT = 'REQUEST_CHANGE_TIME_REPORT'
const READY_CHANGE_TIME_REPORT = 'READY_CHANGE_TIME_REPORT'
const RESET_TIME_REPORT = 'RESET_TIME_REPORT'

const requestChangeTimeReportAction = () => {
  return {
    type: REQUEST_CHANGE_TIME_REPORT
  }
}

const responseChangeTimeReportAction = (name, value) => {
  return {
    type: READY_CHANGE_TIME_REPORT,
    payload: { name, value }
  }
}

const changeTimeReport = (name, value) => {
  return (dispatch) => {
    dispatch(responseChangeTimeReportAction(name, value))
  }
}

const resetTimeReportAction = () => {
  return {
    type: RESET_TIME_REPORT
  }
}

export {
  changeTimeReport,
  requestChangeTimeReportAction,
  responseChangeTimeReportAction,
  resetTimeReportAction,
  REQUEST_CHANGE_TIME_REPORT,
  READY_CHANGE_TIME_REPORT,
  RESET_TIME_REPORT
}
